// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

body .p-component {
  font-size: 0.875rem;
}

body .p-inputtext {
  font-size: 0.875rem;
}

.p-datatable-tbody .p-dropdown .p-dropdown-label {
  width: 340px;
  height: 100%;
}

.p-datatable-tbody .p-dropdown .p-dropdown-trigger {
  width: unset;
  margin-right: 8px;
}

.p-editable-column:has(.p-dropdown) {
  padding: unset;
}

.p-autocomplete-multiple-container .p-autocomplete-input-token {
  flex: unset;
}

.p-datatable .p-column-header-content {
  justify-content: center;
}

.p-datatable div.p-datatable-footer > div {
  display: flex;
  justify-content: center;
}

.p-dialog-content .row > div:has(> small):has(> input, > textarea) {
  display: flex;
  flex-direction: column;
}

.ui-dialog-buttonpane > button:not(:not(:has(+ button))) {
  margin-right: 0.875rem;
}

#palet-smartgrid .p-datatable-footer > div > div,
#palet-externality .p-datatable-footer > div > div {
  width: 100%;
}

.p-dialog-content {
  min-width: 350px;
}

.p-dialog-content > div > .row > div > label {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.p-cell-editing {
  width: 0px;
  padding: 0 0;
}

.probability-col {
  background-color: #e9f3f5;
}

.p-treetable .p-treetable-tbody > tr[aria-level="1"] > td {
  border-left: none;
  border-right: none;
}

.p-treetable .p-treetable-tbody > tr[aria-level="1"] > td:first-child {
  border-left: 1px solid #c8c8c8;
}

.p-treetable .p-treetable-tbody > tr[aria-level="1"] > td:last-child {
  border-right: 1px solid #c8c8c8;
}

.p-treetable .p-treetable-tbody > tr > td {
  border-top: unset;
}

.p-treetable .p-treetable-tbody > tr:first-child {
  box-shadow: 0 0 0 1px #c8c8c8;
}

.p-treetable .p-treetable-thead > tr > th {
  transition: max-height 0.3s ease, padding 0.3s ease, border-color 0.3s ease, background-color 0.3s ease;
  max-height: 3rem;
  overflow: hidden;
  border-bottom: unset;
  background-color: #f4f4f4;
  font-weight: bold;
}

.p-treetable .p-treetable-thead > tr > th > .p-column-header-content {
  transition: opacity 0.3s ease, transform 0.3s ease;
  opacity: 1;
  transform: translateY(0);
}

.kpi-tree-table-header-collapsed .p-treetable-thead > tr > th {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  border-color: transparent;
  background-color: transparent;
}

.kpi-tree-table-header-collapsed .p-treetable-thead > tr > th > .p-column-header-content {
  opacity: 0;
  transform: translateY(-4px);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uGAAuG;EACvG,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;EAClD,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\nbody .p-component {\n  font-size: 0.875rem;\n}\n\nbody .p-inputtext {\n  font-size: 0.875rem;\n}\n\n.p-datatable-tbody .p-dropdown .p-dropdown-label {\n  width: 340px;\n  height: 100%;\n}\n\n.p-datatable-tbody .p-dropdown .p-dropdown-trigger {\n  width: unset;\n  margin-right: 8px;\n}\n\n.p-editable-column:has(.p-dropdown) {\n  padding: unset;\n}\n\n.p-autocomplete-multiple-container .p-autocomplete-input-token {\n  flex: unset;\n}\n\n.p-datatable .p-column-header-content {\n  justify-content: center;\n}\n\n.p-datatable div.p-datatable-footer > div {\n  display: flex;\n  justify-content: center;\n}\n\n.p-dialog-content .row > div:has(> small):has(> input, > textarea) {\n  display: flex;\n  flex-direction: column;\n}\n\n.ui-dialog-buttonpane > button:not(:not(:has(+ button))) {\n  margin-right: 0.875rem;\n}\n\n#palet-smartgrid .p-datatable-footer > div > div,\n#palet-externality .p-datatable-footer > div > div {\n  width: 100%;\n}\n\n.p-dialog-content {\n  min-width: 350px;\n}\n\n.p-dialog-content > div > .row > div > label {\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.p-cell-editing {\n  width: 0px;\n  padding: 0 0;\n}\n\n.probability-col {\n  background-color: #e9f3f5;\n}\n\n.p-treetable .p-treetable-tbody > tr[aria-level=\"1\"] > td {\n  border-left: none;\n  border-right: none;\n}\n\n.p-treetable .p-treetable-tbody > tr[aria-level=\"1\"] > td:first-child {\n  border-left: 1px solid #c8c8c8;\n}\n\n.p-treetable .p-treetable-tbody > tr[aria-level=\"1\"] > td:last-child {\n  border-right: 1px solid #c8c8c8;\n}\n\n.p-treetable .p-treetable-tbody > tr > td {\n  border-top: unset;\n}\n\n.p-treetable .p-treetable-tbody > tr:first-child {\n  box-shadow: 0 0 0 1px #c8c8c8;\n}\n\n.p-treetable .p-treetable-thead > tr > th {\n  transition: max-height 0.3s ease, padding 0.3s ease, border-color 0.3s ease, background-color 0.3s ease;\n  max-height: 3rem;\n  overflow: hidden;\n  border-bottom: unset;\n  background-color: #f4f4f4;\n  font-weight: bold;\n}\n\n.p-treetable .p-treetable-thead > tr > th > .p-column-header-content {\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.kpi-tree-table-header-collapsed .p-treetable-thead > tr > th {\n  max-height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-color: transparent;\n  background-color: transparent;\n}\n\n.kpi-tree-table-header-collapsed .p-treetable-thead > tr > th > .p-column-header-content {\n  opacity: 0;\n  transform: translateY(-4px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
